// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"a30d0bab","511":"a1bb758b","673":"55482259"}[chunkId] + ".chunk.js";
};